import { useNavigation } from '@react-navigation/native'
import React from 'react'
import { Linking, Pressable as RNPressable } from 'react-native'

import { PressableProps } from './types'

export const BasePressable = ({
  children,
  href,
  link,
  stack,
  onPress,
  screenParams = {},
  usePush = false,
  ...props
}: PressableProps) => {
  const navigation = useNavigation<any>()

  const internalOnPress = (e: any) => {
    if (href) {
      let url = href
      url = url?.toLowerCase()
      url = url?.indexOf('http') === -1 ? `http://${url}` : url
      return Linking.openURL(url)
    }
    if (link) {
      if (usePush) {
        return navigation.push(link, {
          ...screenParams,
        })
      }
      if (stack) {
        return navigation.navigate(stack, {
          screen: link,
          params: screenParams,
        })
      }
      return navigation.navigate(link, screenParams)
    }
    return onPress && onPress(e)
  }

  return (
    <RNPressable {...props} onPress={internalOnPress}>
      {children}
    </RNPressable>
  )
}
